module.exports = __webpack_public_path__ + "img/menu.f316d4bb.png";